export const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const COLUMN_SIZING_STORAGE_KEY = 'institutions-table-column-sizing-v1';

export const STICKY_COLUMNS_STORAGE_KEY =
	'institutions-table-sticky-columns-v1';
